/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserCouponAvailablePageRespVo
 */
export interface GetUserCouponAvailablePageRespVo {
    /**
     * 数据编号
     * @type {number}
     * @memberof GetUserCouponAvailablePageRespVo
     */
    id?: number;
    /**
     * 优惠券名
     * @type {string}
     * @memberof GetUserCouponAvailablePageRespVo
     */
    name?: string;
    /**
     * 金额
     * @type {string}
     * @memberof GetUserCouponAvailablePageRespVo
     */
    amount?: string;
    /**
     * 发行类型 1 管理员发放，2 活动发放
     * @type {number}
     * @memberof GetUserCouponAvailablePageRespVo
     */
    grantType?: number;
    /**
     * 发行类型 文字
     * @type {string}
     * @memberof GetUserCouponAvailablePageRespVo
     */
    grantTypeDesc?: string;
    /**
     * 发行种类
     * @type {Array<number>}
     * @memberof GetUserCouponAvailablePageRespVo
     */
    additionalServiceIds?: Array<number>;
    /**
     * 发行种类(说明)
     * @type {string}
     * @memberof GetUserCouponAvailablePageRespVo
     */
    additionalServiceIdsDesc?: string;
    /**
     * 优惠券是否长期有效 0 不是 1 是
     * @type {number}
     * @memberof GetUserCouponAvailablePageRespVo
     */
    longTerm?: number;
    /**
     * 有效期开始时间
     * @type {string}
     * @memberof GetUserCouponAvailablePageRespVo
     */
    beginTime?: string;
    /**
     * 有效期结束时间
     * @type {string}
     * @memberof GetUserCouponAvailablePageRespVo
     */
    endTime?: string;
    /**
     * 发行日期
     * @type {string}
     * @memberof GetUserCouponAvailablePageRespVo
     */
    createTime?: string;
}

/**
 * Check if a given object implements the GetUserCouponAvailablePageRespVo interface.
 */
export function instanceOfGetUserCouponAvailablePageRespVo(value: object): value is GetUserCouponAvailablePageRespVo {
    return true;
}

export function GetUserCouponAvailablePageRespVoFromJSON(json: any): GetUserCouponAvailablePageRespVo {
    return GetUserCouponAvailablePageRespVoFromJSONTyped(json, false);
}

export function GetUserCouponAvailablePageRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserCouponAvailablePageRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'grantType': json['grantType'] == null ? undefined : json['grantType'],
        'grantTypeDesc': json['grantTypeDesc'] == null ? undefined : json['grantTypeDesc'],
        'additionalServiceIds': json['additionalServiceIds'] == null ? undefined : json['additionalServiceIds'],
        'additionalServiceIdsDesc': json['additionalServiceIdsDesc'] == null ? undefined : json['additionalServiceIdsDesc'],
        'longTerm': json['longTerm'] == null ? undefined : json['longTerm'],
        'beginTime': json['beginTime'] == null ? undefined : json['beginTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
    };
}

export function GetUserCouponAvailablePageRespVoToJSON(json: any): GetUserCouponAvailablePageRespVo {
    return GetUserCouponAvailablePageRespVoToJSONTyped(json, false);
}

export function GetUserCouponAvailablePageRespVoToJSONTyped(value?: GetUserCouponAvailablePageRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'amount': value['amount'],
        'grantType': value['grantType'],
        'grantTypeDesc': value['grantTypeDesc'],
        'additionalServiceIds': value['additionalServiceIds'],
        'additionalServiceIdsDesc': value['additionalServiceIdsDesc'],
        'longTerm': value['longTerm'],
        'beginTime': value['beginTime'],
        'endTime': value['endTime'],
        'createTime': value['createTime'],
    };
}

